// extracted by mini-css-extract-plugin
export var hideEditor = "_jk-2";
export var infoIcon = "_jk-3";
export var label = "_jk-1";
export var labelContainer = "_jk-0";
export var readonlyText = "_jk-4";